import univSchoolMedical from "../assets/HomePage/UniversityPrograms/univ-school-medical.png";
import univSchoolBusiness from "../assets/HomePage/UniversityPrograms/univ-school-business.png";
import univSchoolLanguage from "../assets/HomePage/UniversityPrograms/univ-school-language.png";
import univSchoolTechnology from "../assets/HomePage/UniversityPrograms/univ-school-technology.png";
import univSchoolArch from "../assets/HomePage/UniversityPrograms/univ-school-arch.png";
import univSchoolLaw from "../assets/HomePage/UniversityPrograms/univ-school-law.png";
import univSchoolBook from "../assets/HomePage/UniversityPrograms/univ-school-book.png";

export const universityProgramsTabs = [
  { id: "bachelor", name: "Высшего образования" },
  { id: "masters", name: "Повышения квалификации" },
];

export const universityProgramsEducation = [
  {
    name: "Факультет \n медицины",
    path: "education-medical",
    img: univSchoolMedical,
    programs: [
      {
        name: "СКОРАЯ ПОМОЩЬ",
        subName: "Диплом: магистра",
        path: "/single-programs/ambulance",
      },
      {
        name: "АНЕСТЕЗИОЛОГИЯ И РЕАНИМАТОЛОГИЯ",
        subName: "Диплом: магистра",
        path: "/single-programs/anesthesiology-and-resuscitation",
      },
      {
        name: "ОТОРИНОЛАРИНГОЛОГИЯ (ЛОР)",
        subName: "Диплом: магистра",
        path: "/single-programs/cardiology",
      },
      {
        name: "КЛИНИЧЕСКАЯ ПСИХОЛОГИЯ",
        subName: "Диплом: бакалавра",
        path: "/single-programs/clinical-psychology",
      },
      {
        name: "СТОМАТОЛОГИЯ",
        subName: "Диплом: бакалавра, магистра",
        path: "/single-programs/dentistry",
      },
      {
        name: "ДЕРМАТОВЕНЕРОЛОГИЯ",
        subName: "Диплом: магистра",
        path: "/single-programs/dermatovenerology",
      },
      {
        name: "ЭНДОКРИНОЛОГИЯ",
        subName: "Диплом: бакалавра, магистра",
        path: "/single-programs/endocrinology",
      },
      {
        name: "СЕМЕЙНАЯ МЕДИЦИНА",
        subName: "Диплом: магистра",
        path: "/single-programs/family-medicine",
      },
      {
        name: "СУДЕБНО-МЕДИЦИНСКАЯ ЭКСПЕРТИЗА",
        subName: "Диплом: магистра",
        path: "/single-programs/forensic-medical-examination",
      },
      {
        name: "ФУНДАМЕНТАЛЬНАЯ МЕДИЦИНА",
        subName: "Диплом: бакалавра",
        path: "/single-programs/fundamental-medicine",
      },
      {
        name: "ОБЩАЯ ОНКОЛОГИЯ",
        subName: "Диплом: магистра",
        path: "/single-programs/general-oncology",
      },
      {
        name: "МЕНЕДЖМЕНТ В ЗДРАВООХРАНЕНИИ (по направлениям)",
        subName: "Диплом: магистра",
        path: "/single-programs/healthcare-management",
      },
      {
        name: "ИНФЕКЦИОННЫЕ ЗАБОЛЕВАНИЯ",
        subName: "Диплом: магистра",
        path: "/single-programs/infectious-diseases",
      },
      {
        name: "ИНСТРУМЕНТАЛЬНЫЕ И ФУНКЦИОНАЛЬНЫЕ МЕТОДЫ ДИАГНОСТИКИ",
        subName: "Диплом: магистра",
        path: "/single-programs/instumental-and-functional-methods-of-diagnostics",
      },
      {
        name: "МЕДИКО-ПЕДАГОГИЧЕСКОЕ ДЕЛО",
        subName: "Диплом: бакалавра",
        path: "/single-programs/medical-and-preventive-care",
      },
      {
        name: "ЛЕЧЕБНОЕ ДЕЛО",
        subName: "Диплом: бакалавра",
        path: "/single-programs/medical-care",
      },
      {
        name: "МЕДИЦИНСКАЯ ПСИХОЛОГИЯ",
        subName: "Диплом: магистра",
        path: "/single-programs/medical-pshychology",
      },
      {
        name: "МОРФОЛОГИЯ",
        subName: "Диплом: бакалавра, магистра, специалитет",
        path: "/single-programs/morphology",
      },
      {
        name: "НЕВРОЛОГИЯ",
        subName: "Диплом: магистра",
        path: "/single-programs/neurology",
      },
      {
        name: "НЕЙРОХИРУРГИЯ",
        subName: "Диплом: магистра",
        path: "/single-programs/neurosurgery",
      },
      {
        name: "ВЫСШЕЕ МЕДСЕСТРИНСКОЕ ДЕЛО",
        subName: "Диплом: бакалавра",
        path: "/single-programs/nursing",
      },
      {
        name: "АКУШЕРСТВО И ГИНЕКОЛОГИЯ",
        subName: "Диплом: бакалавра, магистра",
        path: "/single-programs/obstetrics-and-gynecology",
      },
      {
        name: "ОФТАЛЬМОЛОГИЯ",
        subName: "Диплом: магистра",
        path: "/single-programs/ophthalmology",
      },
      {
        name: "ОТОРИНОЛАРИНГОЛОГИЯ (ЛОР)",
        subName: "Диплом: магистра",
        path: "/single-programs/otorhinolaryngology",
      },
      {
        name: "ПАТОЛОГИЧЕСКАЯ АНАТОМИЯ",
        subName: "Диплом: магистра",
        path: "/single-programs/pathological-anatomy",
      },
      {
        name: "ПЕДИАТРИЯ",
        subName: "Диплом: бакалавра",
        path: "/single-programs/pediatrics",
      },
      {
        name: "ФАРМАКОЛОГИЯ",
        subName: "Диплом: магистра",
        path: "/single-programs/pharmacology",
      },
      {
        name: "ФАРМАЦИЯ",
        subName: "Диплом: бакалавра, магистра",
        path: "/single-programs/pharmacy",
      },
      {
        name: "ПСИХИАТРИЯ",
        subName: "Диплом: магистра",
        path: "/single-programs/psychiatry",
      },
      {
        name: "ХИРУРГИЯ (по направлениям)",
        subName: "Диплом: магистра",
        path: "/single-programs/surgery",
      },
      {
        name: "ТЕРАПИЯ (по направлениям)",
        subName: "Диплом: магистра",
        path: "/single-programs/therapy",
      },
      {
        name: "НАРОДНАЯ МЕДИЦИНА",
        subName: "Диплом: бакалавра, магистра",
        path: "/single-programs/traditional-medicine",
      },
      {
        name: "ТРАВМАТОЛОГИЯ И ОРТОПЕДИЯ",
        subName: "Диплом: магистра",
        path: "/single-programs/traumatology-and-orthopedics",
      },
      {
        name: "УРОЛОГИЯ",
        subName: "Диплом: магистра",
        path: "/single-programs/urology",
      },
    ],
  },
  {
    name: "Факультет \n бизнеса",
    path: "education-business",
    img: univSchoolBusiness,
    programs: [
      {
        name: "БУХГАЛТЕРСКИЙ УЧЕТ И АУДИТ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/accounting-and-auditing",
      },
      {
        name: "БАНКОВСКОЕ ДЕЛО",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/banking",
      },
      {
        name: "ЦИФРОВОЙ МАРКЕТИНГ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/digital-marketing",
      },
      {
        name: "ЭКОНОМИКА ПРЕДПРИЯТИЙ И ОРГАНИЗАЦИЙ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/economics-of-enterprises-and-organizations",
      },
      {
        name: "ПРЕДПРИНИМАТЕЛЬСТВО",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/entrepreneurship",
      },
      {
        name: "ФИНАНСОВЫЙ МЕНЕДЖМЕНТ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/financial-management",
      },
      {
        name: "МЕЖДУНАРОДНЫЙ БИЗНЕС",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/international-business",
      },
      {
        name: "ЛОГИСТИКА",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/logistics",
      },
    ],
  },
  {
    name: "Факультет социально- \n гуманитарных наук",
    path: "education-sciences",
    img: univSchoolLanguage,
    programs: [
      {
        name: "МЕЖДУНАРОДНЫЕ ОТНОШЕНИЯ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/international-relations",
      },
      {
        name: "ЖУРНАЛИСТИКА",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/journalism",
      },
      {
        name: "ЛИНГВИСТИКА",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/linguistics",
      },
      {
        name: "МЕДИА И DIGITAL-КОММУНИКАЦИИ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/media-and-digital-communications",
      },
      {
        name: "ПЕДАГОГИКА",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/pedagogy",
      },
      {
        name: "ПСИХОЛОГИЯ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/psychology",
      },
      {
        name: "СОЦИОЛОГИЯ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/sociology",
      },
    ],
  },
  {
    name: "Факультет \n IT",
    path: "education-technology",
    img: univSchoolTechnology,
    programs: [
      {
        name: "ИСКУССТВЕННЫЙ ИНТЕЛЛЕКТ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/artificial-intelligence",
      },
      {
        name: "КИБЕРБЕЗОПАСНОСТЬ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/cybersecurity",
      },
      {
        name: "ЦИФРОВАЯ ТРАНСФОРМАЦИЯ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/digital-transformation",
      },
      {
        name: "РАЗРАБОТКА ИГР И МУЛЬТИМЕДИА",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/game-and-multimedia-development",
      },
      {
        name: "ИНФОРМАЦИОННЫЕ СИСТЕМЫ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/information-systems",
      },
      {
        name: "СЕТЕВЫЕ ТЕХНОЛОГИИ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/network-technologies",
      },
      {
        name: "ПРОГРАММИРОВАНИЕ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/programming",
      },
    ],
  },
  {
    name: "Архитектурно- \n инженерный факультет",
    path: "education-arch",
    img: univSchoolArch,
    programs: [
      {
        name: "ДИЗАЙН АРХИТЕКТУРНОЙ СРЕДЫ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/architectural-environment-design",
      },
      {
        name: "АРХИТЕКТУРА",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/architecture",
      },
      {
        name: "АРХИТЕКТУРА И ГРАДОСТРОИТЕЛЬСТВО",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/architecture-and-urban-planning",
      },
      {
        name: "ЭКСПЛУАТАЦИЯ АВТОМОБИЛЬНОГО ТРАНСПОРТА",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/automotive-transport-maintenance",
      },
      {
        name: "БИОМЕДИЦИНСКАЯ ИНЖЕНЕРИЯ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/biomedical-engineering",
      },
      {
        name: "ИНЖЕНЕРИЯ И ЭКСПЛУАТАЦИЯ ЗДАНИЙ И СООРУЖЕНИЙ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/building-engineering-and-maintenance",
      },
      {
        name: "СТРОИТЕЛЬНАЯ ИНЖЕНЕРИЯ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/civil-engineering",
      },
      {
        name: "УПРАВЛЕНИЕ СТРОИТЕЛЬНЫМИ ПРОЕКТАМИ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/construction-project-management",
      },
      {
        name: "ЭНЕРГЕТИЧЕСКОЕ И ВОДОСНАБЖЕНИЕ В СТРОИТЕЛЬСТВЕ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/energy-and-water-supply-in-construction",
      },
      {
        name: "ГЕОДЕЗИЯ И ЗЕМЛЕУСТРОЙСТВО",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/geodesy-and-land-management",
      },
      {
        name: "НЕФТЕГАЗОВОЕ ДЕЛО",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/oil-and-gas-engineering",
      },
      {
        name: "ЖЕЛЕЗНОДОРОЖНЫЙ ТРАНСПОРТ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/railway-transport",
      },
    ],
  },
  {
    name: "Факультет \n права",
    path: "education-law",
    img: univSchoolLaw,
    programs: [
      {
        name: "ГРАЖДАНСКОЕ ПРАВО",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/civil-law",
      },
      {
        name: "КОРПОРАТИВНОЕ ПРАВО",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/corporate-law",
      },
      {
        name: "УГОЛОВНОЕ ПРАВО",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/criminal-law",
      },
      {
        name: "ЭКОЛОГИЧЕСКОЕ ПРАВО",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/environmental-law",
      },
      {
        name: "МЕЖДУНАРОДНОЕ ПРАВО",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/international-law",
      },
      {
        name: "ТРУДОВОЕ ПРАВО",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/labor-law",
      },
      {
        name: "ПРАВО В ЦИФРОВОЙ ЭКОНОМИКЕ",
        subName: "Диплом: бакалавра / магистра",
        path: "/single-programs/law-in-the-digital-economy",
      },
    ],
  },
];

export const universityProgramsQualification = [
  {
    name: "Современные педагогические технологии",
    path: "/single-page/modern-pedagogical-technologies",
    img: univSchoolBook,
    programs: [],
  },
  {
    name: "Цифровизация \n и EdTech",
    path: "/single-page/digitization-and-edtech",
    img: univSchoolBook,
    programs: [],
  },
  {
    name: "Международное сотрудничество и интернационализация",
    path: "/single-page/international-cooperation-and-internationalization",
    img: univSchoolBook,
    programs: [],
  },
  {
    name: "Качество и академическая добросовестность",
    path: "/single-page/quality-and-academic-integrity",
    img: univSchoolBook,
    programs: [],
  },
  {
    name: "Медицина и здравоохранение",
    path: "/single-page/medicine-and-healthcare",
    img: univSchoolBook,
    programs: [],
  },
  {
    name: "Мягкие навыки и ресурсность преподавателя",
    path: "/single-page/soft-skills-and-resources-of-the-teachet",
    img: univSchoolBook,
    programs: [],
  },
  {
    name: "Английский для карьеры и международного общения",
    path: "/single-page/english-for-career-and-international-communication",
    img: univSchoolBook,
    programs: [],
  },
  {
    name: "Инновации и проектное мышление в высшем образовании",
    path: "/single-page/innovation-and-project-thinking-in-higher-education",
    img: univSchoolBook,
    programs: [],
  },
];
